import { useQuery } from "@tanstack/react-query";

import { getFullArticle, getFullNews, getRelatedArticles, getRelatedNews } from "services";

import { DEFAULT_CACHE_TIME } from "consts";

import { ARTICLE_TYPE, Article } from "models";

export const useGetFullNews = ({ link = "unkown" }: { link: string }) => {
  const { data, isLoading } = useQuery<Article>({
    queryKey: ["getFullNews", link],
    queryFn: ({ signal }) => getFullNews({ signal, link }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  if (!link || link === "") return { news: null, newsIsLoading: isLoading };

  return { news: data || null, newsIsLoading: isLoading };
};

export const useGetRelatedNews = ({ link = "unkown" }: { link: string }) => {
  const { data, isLoading } = useQuery<Article[]>({
    queryKey: ["getRelatedNews", link],
    queryFn: ({ signal }) => getRelatedNews({ signal, link }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  if (!link || link === "") return { news: [], newsIsLoading: isLoading };

  return { news: data || [], newsIsLoading: isLoading };
};

export const useGetFullArticle = ({ link = "unkown" }: { link: string }) => {
  const { data, isLoading } = useQuery<Article>({
    queryKey: ["getFullArticle", link],
    queryFn: ({ signal }) => getFullArticle({ signal, link }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  if (!link || link === "") return { article: null, articleIsLoading: isLoading };

  return { article: data || null, articleIsLoading: isLoading };
};

export const useGetRelatedArticles = ({ link = "unkown" }: { link: string }) => {
  const { data, isLoading } = useQuery<Article[]>({
    queryKey: ["getRelatedArticles", link],
    queryFn: ({ signal }) => getRelatedArticles({ signal, link }),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  if (!link || link === "") return { articles: [], articleIsLoading: isLoading };

  return { articles: data || [], articleIsLoading: isLoading };
};

export const useGetFullArticleOrNews = ({ link = "unkown", type }: { link: string; type: ARTICLE_TYPE }) => {
  const { data, isLoading } = useQuery<Article>({
    queryKey: [type === ARTICLE_TYPE.NEWS ? "getFullNews" : "getFullArticle", link, type],
    queryFn: ({ signal }) => (type === ARTICLE_TYPE.NEWS ? getFullNews({ signal, link }) : getFullArticle({ signal, link })),
    gcTime: DEFAULT_CACHE_TIME * 7,
    staleTime: DEFAULT_CACHE_TIME * 7,
  });

  if (!link || link === "") return { article: null, articleIsLoading: isLoading };

  return { article: data || null, articleIsLoading: isLoading };
};
